import type { TranslationMessages } from '../types';

export const auth: TranslationMessages = {
  change_password: 'Thay đổi mật khẩu',
  logout: 'Đăng xuất',
  forgot_password: 'Quên mật khẩu?',
  remember_password: 'Ghi nhớ mật khẩu',
  reset_password: 'Đặt lại mật khẩu',
  email: 'Email',
  username_email_password_required: 'Tên người dùng/email và mật khẩu là bắt buộc',
  invalid_credentials: 'Tên người dùng/email hoặc mật khẩu không đúng',
  invalid_username_email: 'Tên người dùng/email không đúng',
  invalid_password: 'Mật khẩu không đúng',
  invalid_username: 'Tên người dùng không đúng',
  invalid_email: 'Email không đúng',
  invalid_username_or_email: 'Tên người dùng/email không đúng',
  close_window: 'Đóng',
  set_new_password: 'Cập nhật mật khẩu',
  username_or_email: 'Tên người dùng/email',
  username_or_email_placeholder: 'Nhập tên đăng nhập hoặc email',
  password: 'Mật khẩu',
  password_placeholder: 'Nhập mật khẩu của bạn',
  sign_in: 'Đăng nhập',
  welcome_back: 'Chào mừng trở lại! Vui lòng đăng nhập vào tài khoản của bạn.',
  or: 'hoặc',
  sign_in_with_passkey: 'Đăng nhập bằng Passkey',
  passkey_error: 'Đăng nhập bằng passkey thất bại',
  passkey_not_supported: 'Thiết bị này không hỗ trợ passkey',
  no_passkeys:
    'Chưa có passkey nào được đăng ký. Vui lòng đăng nhập bằng tên người dùng/mật khẩu trước, sau đó đăng ký passkey trong cài đặt hồ sơ của bạn.',
  passkey_register: 'Đăng ký Passkey',
  passkey_register_success: 'Đăng ký passkey thành công',
  passkey_register_error: 'Đăng ký passkey thất bại',
  passkey_not_registered:
    'Chưa có passkey nào được đăng ký. Vui lòng đăng nhập bằng tên người dùng/mật khẩu trước, sau đó đăng ký passkey trong cài đặt hồ sơ của bạn.',
  register_passkey: 'Đăng ký Passkey',
  register_passkey_description:
    'Bạn có muốn thiết lập passkey để đăng nhập nhanh hơn và an toàn hơn không? Bạn có thể sử dụng vân tay, nhận diện khuôn mặt hoặc mã PIN thiết bị.',
  register_passkey_button: 'Đăng ký Passkey',
  register_passkey_error: 'Đăng ký passkey thất bại',
  register_passkey_success: 'Đăng ký passkey thành công',
  register_passkey_ios_guidance:
    'Phát hiện thiết bị iOS: Đảm bảo bạn đã thiết lập Face ID, Touch ID hoặc mã PIN thiết bị. Khi được nhắc, hoàn thành xác thực sinh trắc học để đăng ký passkey của bạn.',
  passkey_ios_cancelled:
    'Đăng ký passkey đã bị hủy. Vui lòng thử lại và đảm bảo bạn hoàn thành xác thực sinh trắc học.',
  passkey_ios_security_error:
    'Lỗi bảo mật trong quá trình đăng ký passkey. Vui lòng đảm bảo bạn đang sử dụng HTTPS và thử lại.',
  passkey_ios_invalid_state:
    'Passkey đã tồn tại cho tài khoản này. Vui lòng thử đăng nhập bằng passkey của bạn thay vào đó.',
  passkey_ios_not_supported:
    'Đăng ký passkey đã bị hủy hoặc không được hỗ trợ trên thiết bị này. Vui lòng đảm bảo bạn đã thiết lập Face ID, Touch ID hoặc mã PIN thiết bị.',
  password_changed_successfully: 'Đổi mật khẩu thành công',
  current_password_incorrect: 'Mật khẩu hiện tại không đúng',
  new_password_required: 'Tất cả các trường là bắt buộc',
  new_passwords_do_not_match: 'Mật khẩu mới không khớp',
  new_password_min_length: 'Mật khẩu mới phải có ít nhất 8 ký tự',
  current_password: 'Mật khẩu Hiện tại',
  new_password: 'Mật khẩu Mới',
  confirm_new_password: 'Xác nhận Mật khẩu Mới',
  not_authenticated: 'Chưa xác thực',
  change_password_description: 'Nhập mật khẩu hiện tại của bạn và chọn mật khẩu mới',
  qr_login: {
    switch_user: 'Chuyển đổi người dùng',
    description:
      'Quét mã QR bằng thiết bị di động của bạn để đăng nhập. Chia sẻ mã xác minh khi được yêu cầu.',
    generating: 'Đang tạo mã QR...',
    verification_code: 'Mã xác minh',
    code_help: 'Chia sẻ mã này khi xác nhận trên thiết bị di động của bạn',
    expires_in: 'Hết hạn sau',
    expired: 'Mã QR đã hết hạn',
    waiting_confirmation: 'Đang chờ xác nhận...',
    session_expired: 'Phiên đã hết hạn',
    already_used: 'Đã sử dụng',
    refresh: 'Làm mới',
    code_copied: 'Đã sao chép mã!',
    success: 'Đăng nhập thành công!',
    logging_in: 'Đang đăng nhập...',
    confirm_login: 'Xác nhận đăng nhập',
    confirm_description:
      'Vui lòng xác nhận rằng bạn muốn đăng nhập trên thiết bị khác. Mã xác minh đã được tự động điền cho bạn.',
    logging_in_as: 'Đang đăng nhập với tư cách',
    code_instructions: 'Nhập mã xác minh 6 ký tự hiển thị trên thiết bị khác',
    confirmed: 'Đã xác nhận!',
    redirecting: 'Đang chuyển hướng...',
    not_logged_in: 'Chưa đăng nhập',
    must_login_first:
      'Bạn phải đăng nhập trên thiết bị này để xác nhận đăng nhập trên thiết bị khác.',
    confirming: 'Đang xác nhận...',
    confirmation_success: 'Xác nhận đăng nhập thành công!',
    confirmation_failed: 'Xác nhận thất bại',
    confirmation_error: 'Đã xảy ra lỗi trong quá trình xác nhận',
    invalid_session: 'ID phiên không hợp lệ',
    invalid_code_format: 'Vui lòng nhập mã xác minh 6 ký tự hợp lệ',
    must_be_logged_in: 'Bạn phải đăng nhập trên thiết bị di động để xác nhận',
  },
  recent_users: 'Người dùng gần đây',
};

